export default {
  editSuccess: 'success',
  week: 'Week',
  weeklyMode: 'Weekly Mode',
  originalMode: 'Original Mode',
  outputDesc: 'Q Output Description',
  progress: 'Current Progress',
  risk: 'Current Risk',
  comments: 'Notes & Comments',
  editWeekly: 'Edit Weekly Report',
  notes: 'Notes',
  commentWeekly: 'Comments',
  current: 'View Current Date Content Only',
  all: 'View All Content',
  required: 'required',
  placeholder: 'please input',
  quarters: [
    'First Quarter',
    'Second Quarter',
    'Third Quarter',
    'Fourth Quarter'
  ],
  head: 'Holder',
  item: 'Item',
  export: 'export',
  currentRisk: 'current risk',
  exportConfirm: 'confirm',
  exportCancel: 'cancel',
  collaborativeUser: 'collaborators',
  originData: 'origin',
  checkComment: 'comment',
  edit: 'edit'
}
